import {DestroyRef, inject, Injectable} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {merge, switchMap} from 'rxjs';
import {AccountClosedEvent} from 'src/app/shared/application/events/account/account-closed.event';
import {AccountResetRequestedEvent} from 'src/app/shared/application/events/account/account-reset-requested.event';
import {BookingExitedEvent} from "@shared/application/events/booking/booking-exited.event";
import {BookingClosedEvent} from "@shared/application/events/booking/booking-closed.event";
import {EVENT_BUS} from "@shared/domain/tokens/event-bus.token";
import {CreateAccountUseCase} from '../use-cases/create-account.usecase';

@Injectable({providedIn: 'root'})
export class CreateAccountSubscriber {
  private readonly createAccountUseCase = inject(CreateAccountUseCase);
  private readonly eventBus = inject(EVENT_BUS);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    merge(
      this.eventBus.ofType(AccountResetRequestedEvent),
      this.eventBus.ofType(AccountClosedEvent),
      this.eventBus.ofType(BookingExitedEvent),
      this.eventBus.ofType(BookingClosedEvent),
    ).pipe(
      switchMap(() => this.createAccountUseCase.execute()),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe();
  }
}
